import React, { Component } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";
import '../../css/BisharatMain.css';
import AuthService from "../../services/AuthService";
import { MemberLinkBtn, MemberLinkBtnGold } from "../../styles/Elements";
import Login from "../../pages/Login";
// import logo from '../data/images/logo.png';

const required = value => {
  if (!value) {
    return (
      <div className="alertDanger" role="alert">
        <p className="alertDanger">اجباري
          </p> 
      </div>
    );
  }
};

const email = value => {
  if (!isEmail(value)) {
    return (
      <div className="alertDanger" role="alert">
        <p className="alertDanger">
       بريد الكتروني غير ملائم
       </p>
      </div>
    );
  }
};

const vusername = value => {
  if (value.length < 3 || value.length > 20) {
    return (
      <div className="alertDanger" role="alert">
        <p className="alertDanger">
      اسم مستخدم غير ملائم
      </p>
      </div>
    );
  }
};

const vpassword = value => {
  if (value.length < 6 || value.length > 40) {
    return (
      <div className="alertDanger" role="alert">
      <p className="alertDanger">
        كلمة المرور غير ملائمة
      </p>
      </div>
    );
  }
};

export default class CreateModerator extends Component {
  constructor(props) {
    super(props);
    this.handleRegister = this.handleRegister.bind(this);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);

    this.state = {
      username: "",
      email: "",
      password: "",
      successful: false,
      message: ""
    };
  }

  onChangeUsername(e) {
    this.setState({
      username: e.target.value
    });
  }

  onChangeEmail(e) {
    this.setState({
      email: e.target.value
    });
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value
    });
  }

  handleRegister(e) {
    e.preventDefault();

    this.setState({
      message: "",
      successful: false
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {
      AuthService.registerMOD(
        this.state.username,
        this.state.email,
        this.state.password
      ).then(
        response => {
          this.setState({
            message: response.data.message,
            successful: true
          });
        },
        error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            successful: false,
            message: resMessage
          });
        }
      );
    }
  }

  render() {
    const loggedInUser = AuthService.getCurrentUser();
    const whatRole = AuthService.getUserRole();
    
    return (

      <div className='mainCreate'>
         <div className="top-container-forms modcreate-topform">
         <div className="create-form modcreate-form"> 
{!loggedInUser || (whatRole === ('USER')) || whatRole === ('MODERATOR') ? 
        <Login></Login>
  : 
        <div className="register-not-signed">
   
          <Form
            onSubmit={this.handleRegister}
            ref={c => {
              this.form = c;
            }}
          >
            {!this.state.successful && (
              <div>
                <div className="form-group">
                  <label htmlFor="username">اسم المستخدم</label>
                  <Input
                    type="text"
                    className="form-control-mod"
                    name="username"
                    value={this.state.username}
                    onChange={this.onChangeUsername}
                    validations={[required, vusername]}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">بريد الكتروني</label>
                  <Input
                    type="text"
                    className="form-control-mod"
                    name="email"
                    value={this.state.email}
                    onChange={this.onChangeEmail}
                    validations={[required, email]}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="password">كلمة المرور</label>
                  <Input
                    type="password"
                    className="form-control-mod"
                    name="password"
                    value={this.state.password}
                    onChange={this.onChangePassword}
                    validations={[required, vpassword]}
                  />
                </div>

                <div className="form-group">
                  <button className="btn btn-primary btn-block">اضافة</button>
                  <MemberLinkBtnGold to={'/adminboard/'}> Back to Admin Board  </MemberLinkBtnGold> 
                </div>
                
              </div>
            )}

            {this.state.message && (
              <div className="form-group">
                <div
                  className={
                    this.state.successful
                      ? "alertSuccess" 
                      : "alertDanger"
                  }
                  role="alert"
                >
                  
                  {this.state.message} 
                  
                </div>
                <MemberLinkBtn to={'/login'}> للعودة </MemberLinkBtn>
              </div>
            )}
            <CheckButton
              style={{ display: "none" }}
              ref={c => {
                this.checkBtn = c;
              }}
            />
          </Form>
        
      </div>
      }
      </div>
      {/* <div className="top-box-register top-box-register-a">
         <img src= {logo} alt="logo1"/>
         <p> Do you like our new LOGO ? </p>
        </div>

        <div className="top-box-register top-box-register-b">
              <h1>TOP BOX B1</h1>
              <p> اعلانات</p>
</div> */}

      </div>
        </div>
    );
  }
}